module.exports = __webpack_public_path__ + "img/firstBanner.7415d6a8.png";